import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ANNUAL_RETURN_FORM, NEW_APPLICATION_FORM, CHARITABLE_NOTIFICATION_OF_CHANGE_FORM } from '../constants';

const applicationsMapping = {
  'annual-return': ANNUAL_RETURN_FORM,
  'new-application': NEW_APPLICATION_FORM,
  'notification-change': CHARITABLE_NOTIFICATION_OF_CHANGE_FORM
};

export const RedirectIfCaptchaNotSelected = (props) => {
  const captcha = useSelector((state) => state.captcha);
  const initialPageUrl = window.location.pathname.split('/').filter((i) => i)[0];
  const form = useSelector((state) => state.form);

  useEffect(() => {
    if (process.env.REACT_APP_CAPTCHA_ENABLED === 'false') {
      return;
    }
    if (applicationsMapping[form.form] && !captcha[applicationsMapping[initialPageUrl]]) {
      props.history.push(`/${initialPageUrl}`);
    }
  });
};

export const RedirectIfFormNotSelected = (props) => {
  const form = useSelector((state) => state.form);
  let initialPageUrl = window.location.pathname.split('/').filter((i) => i)[0];

  if (initialPageUrl === NEW_APPLICATION_FORM) {
    const appTypeUrl = window.location.pathname.split('/').filter((i) => i)[1];
    initialPageUrl = `${initialPageUrl}/${appTypeUrl}`;
  }

  if (!form.form) {
    props.history.push(`/${initialPageUrl}`);
  }
};
